import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import { EnergyLevelListing } from 'types/listing/listings'

const getEnergyLevel = async () => {
  const response = await axiosGet(`v1/energyLevel`)
  return response.data
}

export const useGetEnergyLevel = () => {
  const energyLevel = useQuery<EnergyLevelListing[]>(
    [`all-energy-level-listings`],
    getEnergyLevel,
    {
      enabled: false,
    },
  )
  return energyLevel
}

// add energy level
const createEnergyLevel = async (payload: { name: string; iconId: string }) => {
  const response = await axiosPost(payload, `v1/energyLevel`)
  return response.data
}
export const useCreateEnergyLevel = () => {
  const queryClient = useQueryClient()
  return useMutation(createEnergyLevel, {
    onSuccess: (newItem: EnergyLevelListing) => {
      queryClient.setQueryData(
        ['all-energy-level-listings'],
        (oldData: EnergyLevelListing[] | undefined) => {
          if (!oldData) return [newItem]
          return [...oldData, newItem]
        },
      )
    },
  })
}

// update energy level
const updateEnergyLevel = async ({
  energyLevelId,
  payload,
}: {
  energyLevelId: string
  payload: { name: string; iconId: string }
}) => {
  const response = await axiosPatch(payload, `v1/energyLevel/${energyLevelId}`)
  return response.data
}

export const useUpdateEnergyLevel = () => {
  const queryClient = useQueryClient()
  return useMutation(updateEnergyLevel, {
    onSuccess: updateEnergyLevel => {
      queryClient.setQueryData(
        ['all-energy-level-listings'],
        (oldData: EnergyLevelListing[] | undefined) => {
          if (!oldData) return [updateEnergyLevel]
          return oldData.map(energyLevel =>
            energyLevel._id === updateEnergyLevel._id
              ? updateEnergyLevel
              : energyLevel,
          )
        },
      )
    },
  })
}

// delete energy level
const deleteEnergyLevel = async (energyLevelId: string) => {
  const response = await axiosDelete(`v1/energyLevel/${energyLevelId}`)
  return response.data
}

export const useDeleteEnergyLevel = () => {
  const queryClient = useQueryClient()
  return useMutation(deleteEnergyLevel, {
    onSuccess: (deletedEnergyLevel: EnergyLevelListing) => {
      queryClient.setQueryData(
        ['all-energy-level-listings'],
        (oldData: EnergyLevelListing[] | undefined) => {
          if (!oldData) return [deletedEnergyLevel]
          return oldData.filter(
            energyLevel => energyLevel._id !== deletedEnergyLevel._id,
          )
        },
      )
    },
  })
}
